import { useState } from 'react'
import toast from 'react-hot-toast'
import { useQueryClient } from 'react-query'
import { useDeleteAccess } from '../../api/stage'
import StageAccess from '../../types/stage-access'
import Checkbox from '../common/Checkbox'
interface Props extends StageAccess {
  pid?: string
}

export default function StageAccessRow({
  pid = '',
  id = '',
  read,
  write,
  account,
}: Props) {
  const deleteAccess = useDeleteAccess()
  const queryClient = useQueryClient()
  const [canRead, setCanRead] = useState<boolean>(read)
  const [canWrite, setCanWrite] = useState<boolean>(write)

  async function submitRequest() {
    await deleteAccess.mutateAsync(id, {
      onSuccess: () => {
        queryClient.invalidateQueries(`accesses-${pid}`)
        toast.success('دسترسی مورد نظر حدف شد')
      },
    })
  }
  return (
    <tr className="text-xs animate-fadeIn">
      <td>
        <img
          alt="remove"
          src="/icons/close.svg"
          className="remove-access-button cursor-pointer hover:bg-red-100 rounded transition-all"
          onClick={submitRequest}
        />
      </td>
      <td>{account.fullName}</td>
      <td className="text-center">
        <Checkbox
          readonly
          value={canWrite}
          // onChange={(e) => setCanWrite(e.target.checked)}
          className="text-gray-600"
        />
      </td>
      <td className="text-center">
        <Checkbox
          readonly
          value={canRead}
          // onChange={(e) => setCanRead(e.target.checked)}
          className="text-gray-600"
        />
      </td>
    </tr>
  )
}
